export default __webpack_public_path__ + "static/index-title-feature-en-caa67f87772d9e6ffbaa16cd56b66b91.png";